import { render } from "./usermessage.vue?vue&type=template&id=addf281e&scoped=true"
import script from "./usermessage.vue?vue&type=script&lang=js"
export * from "./usermessage.vue?vue&type=script&lang=js"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-addf281e"]])

export default __exports__